import { createSlice } from "@reduxjs/toolkit";
import { updateCart } from "../utils/cartUtils.js";

const initialState = localStorage.getItem("cart")
    ? JSON.parse(localStorage.getItem("cart"))
    : {
        cartItems: [],
        shippingAddress: {},
        paymentMethod: '',
        noFeeShippingTax: false
    };

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        addToCart: (state, action) => {
            const item = action.payload;
            const itemExists = state.cartItems.find((x) => x._id === item._id && x.selectedPriceCustomization === item.selectedPriceCustomization && ((x.subCategory === "Hot Snacks" && x.selectedSpiceLevel === item.selectedSpiceLevel) || (x.subCategory === "Sweets" && x.selectedSweetness === item.selectedSweetness)));
            if (itemExists) {
                state.cartItems = state.cartItems.map((x) => x._id === itemExists._id && x.selectedPriceCustomization === itemExists.selectedPriceCustomization && ((x.subCategory === "Hot Snacks" && x.selectedSpiceLevel === itemExists.selectedSpiceLevel) || (x.subCategory === "Sweets" && x.selectedSweetness === itemExists.selectedSweetness)) ? item : x);
            } else {
                state.cartItems = [...state.cartItems, item];
            }

            return updateCart(state);
        },
        removeFromCart: (state, action) => {
            const item = action.payload;

            state.cartItems = state.cartItems.filter((x) => {
                // different product → keep
                if (x._id !== item._id) return true;
                // different price customization → keep
                if (x.selectedPriceCustomization !== item.selectedPriceCustomization) return true;
                // Hot Snacks → match spice
                if (
                    x.subCategory === "Hot Snacks" &&
                    x.selectedSpiceLevel !== item.selectedSpiceLevel
                ) {
                    return true;
                }
                // Sweets → match sweetness
                if (
                    x.subCategory === "Sweets" &&
                    x.selectedSweetness !== item.selectedSweetness
                ) {
                    return true;
                }
                // exact match → REMOVE
                return false;
            });
            return updateCart(state);
        },
        saveShippingAddress: (state, action) => {
            state.shippingAddress = action.payload;
            return updateCart(state);
        },
        savePaymentMethod: (state, action) => {
            state.paymentMethod = action.payload;
            return updateCart(state);
        },
        clearCartItems: (state, action) => {
            state.cartItems = [];
            return updateCart(state);
        },
        toggleNoFeeShippingTax: (state) => {
            state.noFeeShippingTax = !state.noFeeShippingTax;
            return updateCart(state);
        },
        resetCart: (state) => (state = initialState)
    }
})

export const {
    addToCart,
    removeFromCart,
    saveShippingAddress,
    savePaymentMethod,
    clearCartItems,
    resetCart,
    toggleNoFeeShippingTax
} = cartSlice.actions;

export default cartSlice.reducer;